import React from 'react';
import Transporte from '../paquetes-detalle/paquete-detalle-transporte/paquete-detalle-transporte';
import Hoteles from '../paquetes-detalle/detalle-eurovips/paquete-detalle-hoteles/paquete-detalle-hoteles';
import InformacionAdicional from '../paquetes-detalle/paquete-detalle-informacion-adicional/paquete-detalle-informacion-adicional';
import Itinerario from '../paquetes-detalle/paquete-detalle-itinerario/paquete-detalle-itinerario';
import Incluye from '../paquetes-detalle/paquete-detalle-incluye/paquete-detalle-incluye';
import SeccionConTitulo from '../paquetes-detalle/seccion-detalle/seccion-con-titulo';

import './detalle.css';

const DetalleOla = (props) => {
  return (
    <span className='confirmacion-pago'>
      <SeccionConTitulo titulo='Aéreos'>
        <Transporte
          ida={
            props.paquete.salidas[0].transporte.transporteAereo
              .itinerarioVuelo.informeIda
          }
          vuelta={
            props.paquete.salidas[0].transporte.transporteAereo
              .itinerarioVuelo.informeVuelta
          }
          imagen={
            props.paquete.salidas[0].transporte.transporteAereo.imagen
          }
        />
      </SeccionConTitulo>
      <SeccionConTitulo titulo='Alojamientos'>
        <Hoteles
          destinos={props.paquete.salidas[0].destinosHoteles}
          hoteles={props.paquete.salidas[0].hoteles}
        />
      </SeccionConTitulo>
      <SeccionConTitulo titulo='Descripción'>
        {props.paquete.metaDescripcion !== null && (
          <Incluye descripcion={props.paquete.metaDescripcion} />
        )}
        <Itinerario itinerario={props.paquete.salidas[0].itinerario.descripcion} />

        <InformacionAdicional
          observaciones={props.paquete.salidas[0].observaciones}
        />
      </SeccionConTitulo>
    </span>
  );
};

export default DetalleOla;
